import React from 'react';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Header from '../../components/Header';

const TermsAndConditions = () => {
  useDocumentTitle('Terms & Conditions');

  return (
    <div className="inner-wrapper">
      <Header />
      <div className="container">
        <h1 className="site-color-dark-red mb-4">Terms & Conditions</h1>
        <div className="static-content">
          <p>These Terms and Conditions govern the use of the website <strong>https://www.nirakarsatguru.org</strong> and the mobile application "Nirakar Satguru" managed by <strong>Shree Mahatab Jankalyan Adhyatmik Satsang Samiti</strong> ("we", "us", or "our").</p>

          <h2>Acceptance</h2>
          <p>By accessing our website or app, you agree to be bound by these terms. If you do not agree, please do not use the services.</p>

          <h2>Use of Services</h2>
          <p>The website/app is intended solely for non-commercial, spiritual, and informational purposes. Misuse or unauthorized reproduction of content is prohibited.</p>

          <h2>Intellectual Property</h2>
          <p>All content including texts, images, videos, and code are the property of the Samiti. Unauthorized copying, distribution or commercial use is not permitted.</p>

          <h2>User Conduct</h2>
          <ul>
            <li>Do not post harmful, abusive, or inappropriate content.</li>
            <li>Do not impersonate others or spread misinformation.</li>
            <li>Do not interfere with the functioning of the website/app.</li>
          </ul>

          <h2>Donations</h2>
          <p>All donations made via the website/app are voluntary. <strong>No refunds</strong> will be issued once the donation is processed.</p>

          <h2>Communication</h2>
          <p>By registering, you consent to receive updates and spiritual content via SMS, email, or WhatsApp. You may unsubscribe by contacting <a href="mailto:info@nirakarsatguru.org">info@nirakarsatguru.org</a>.</p>

          <h2>Disclaimer</h2>
          <p>The Samiti provides content to inspire spiritual growth. We are not liable for any psychological or emotional impact. Please consult a professional if you have a medical condition.</p>

          <h2>Access & Security</h2>
          <p>You are responsible for safeguarding your login credentials. We are not liable for unauthorized use of your account.</p>

          <h2>Age Requirement</h2>
          <p>Users under 18 should only use the app/website under parental guidance.</p>

          <h2>Termination</h2>
          <p>We reserve the right to suspend or terminate user access for violation of terms.</p>

          <h2>Jurisdiction</h2>
          <p>These terms shall be governed by Indian laws. Disputes shall be subject to jurisdiction in <strong>Kanpur</strong>.</p>

          <h2>Policy Updates</h2>
          <p>We may revise these terms from time to time. Continued use implies acceptance of updated terms.</p>

          <h2>Contact</h2>
          <p>For queries, contact:</p>
           <p>Shri Ravindra Nath Tiwari<br/>
          Secretary,<br/>
          Shree Mahatab Jankalyan Adhyatmik Satsang Samiti<br/>
            📧 <a href="mailto:support@nirakarsatguru.org">support@nirakarsatguru.org</a><br />
            Phone: +91-9651303202
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
